<template>
  <div class="card" v-show="currentCardId == 'company'">
    <div class="overflow-scroll-y">
      <div class="card-header">
        <h2>応募会社</h2>
        <p>送付状に記載する会社名と担当者情報を記載しましょう</p>
      </div>
      <div class="card-content">
        <div class="edit-form">
          <div class="edit-form-item">
            <div class="item-name">応募する会社名</div>
            <div class="item-body">
              <el-input
                placeholder="株式会社Yagish"
                class="input-md"
                title="応募する会社名"
                v-model="formatData.company_name"
              />
            </div>
          </div>
          <div class="edit-form-item">
            <div class="item-name">
              応募会社の担当者&#12288;※敬称(様)を記載しないでください。
            </div>
            <div class="item-body">
              <el-input
                placeholder="ご担当者"
                class="input-md"
                title="応募会社の担当者"
                v-model="formatData.staff_name"
              />
            </div>
            <div class="attention-limit character" v-if="staffNameError">
              <i class="el-icon-warning"></i>
              「様」や「さま」の入力が見つかりました。敬称(様)は自動入力されますので、入力しないでください。
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useLetterFormatData } from '@/composables/format-edit/useLetterFormatData'

defineProps<{
  currentCardId?: string
}>()

const formatData = useLetterFormatData()

const staffNameError = computed(() => {
  const name = formatData.staff_name || ''
  return name.indexOf('さま') >= 0 || name.indexOf('様') >= 0
})
</script>
